/* eslint-env browser */
import * as React from 'react'

import { insertURLParameter } from '../../../common/client/url-manipulator'

require('../../../container/client')

const ReactDOM = require('react-dom')

const DomHelper = require('../../../client/clientjs/dom-helper')
const FullGear = require('../../../client/clientjs/components/Gear/FullGear')
const PubSub = require('../../../client/clientjs/services/pub-sub')

function getUrlParams(search) {
  const hashes = search.slice(search.indexOf('?') + 1).split('&')
  const params = {}
  hashes.forEach(hash => {
    const [key, val] = hash.split('=')
    params[key] = decodeURIComponent(val)
  })
  return params
}

const onChangeSelectedArticle = articleSeoName => {
  insertURLParameter('pa', articleSeoName)
}

DomHelper.onDocumentReady(() => {
  window.onpopstate = e => {
    const params = getUrlParams(window.location.search)
    PubSub.pub('fullGearProductArticleDidChange', { paSeoName: params.pa })
  }

  const renderFullCatch = DomHelper.query('#react-render-gear')
  if (renderFullCatch) {
    ReactDOM.hydrate(
      <FullGear
        locale={window.initialState.locale.identifierShort}
        product={window.initialState.product}
        selectedProductArticleSeoName={window.initialState.selectedProductArticleSeoName}
        productCategory={window.initialState.productCategory}
        brand={window.initialState.brand}
        articleCatches={window.initialState.articleCatches}
        modelCatches={window.initialState.modelCatches}
        productCatches={window.initialState.productCatches}
        species={window.initialState.species}
        mostAssociatedGear={window.initialState.mostAssociatedGear}
        latestUsers={window.initialState.latestUsers}
        opinions={window.initialState.opinions}
        opinionsGlobalNote={window.initialState.opinionsGlobalNote}
        currentUserOpinion={window.initialState.currentUserOpinion}
        isLoggedIn={window.initialState.isLoggedIn}
        host={window.initialState.config.host}
        onChangeSelectedArticle={onChangeSelectedArticle}
      />,
      renderFullCatch
    )
  }
})

if (module.hot) {
  module.hot.accept()
}
